import { useEffect } from 'react';
import useInterviewType from 'src/interviews/hooks/useInterviewType';
import useParentTransition from 'src/interviews/hooks/useParentTransition';
import DiagnosisOfConcernCompletion from './DiagnosisOfConcern';
import EmergencyCompletion from './Emergency';
import SymptomsCompletion from './Symptoms';

import type { IInterviewResults, IMiniInterviewProps } from 'src/packages/polaris/types';

type Props = {
  conditionName: string;
  polarisProps?: IMiniInterviewProps['polarisProps'];
  result: IInterviewResults;
  slug: string;
};

function InterviewCompletion({ result, ...rest }: Props) {
  const interviewType = useInterviewType();

  switch (interviewType) {
    case 'dxoc':
      return <DiagnosisOfConcernCompletion result={result} {...rest} />;
    case 'emergency':
      return <EmergencyCompletion result={result} />;
    case 'symptoms':
      return <SymptomsCompletion result={result} {...rest} />;
    default:
      return null;
  }
}

const Completion = ({ result, ...rest }: Props) => {
  const parentTransition = useParentTransition();

  useEffect(() => {
    // At completion, save results token for interview hopping purposes
    parentTransition({
      event: 'INTERVIEW_COMPLETION',
      data: {
        resultsToken: result.token,
      },
    });
  }, [result.token]);

  return <InterviewCompletion result={result} {...rest} />;
};

export default Completion;
